import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';
import axios from 'axios';
import { useSelector } from "react-redux";

const fetchDeviceReport = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_URL}/api/deviceReport`, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
    //console.log(response.data, "........data in report");
    return response.data;
  } catch (error) {
   // console.error('Error fetching device report:', error);
    return null;
  }
};

const Device_Addition = () => {
  const [userRole, setUserRole] = useState('');
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [renderContenttttt, setRenderContenttttt] = useState(null);
  const NewDevice = useRef(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState('');

          const token = useSelector((state) => state.auth.token);


  useEffect(() => {
    const getData = async () => {

      try {
        const response_data = await fetchDeviceReport();
        setTabHeading(response_data?.heading || null);

        if (response_data?.data && response_data.data.length > 0) {
          // console.log("Setting report data:", response_data.data);
          setReportData(response_data.data);

          // ✅ Get user role from first data record
          const roleFromResponse = response_data.data[0]?.role;
          if (roleFromResponse !== undefined && roleFromResponse !== null) {
            setUserRole(String(roleFromResponse));
          }

        } else {
          setReportData([]);
        }
      } catch (error) {
       // console.error("Error fetching data:", error);
        setError("Internal error");
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && NewDevice.current) {
      window.scrollTo({
        top: NewDevice.current.offsetTop,
        behavior: 'smooth',
      });
    }
  }, [loading, error, reportData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0);
  };

  const filteredData = reportData.filter(item =>
    item?.terminal_id?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  if (error) {
    return <div className="mainhead" align="center">{error}</div>;
  }

  if (reportData.length === 0) {
    return <div className="mainhead" align="center">No data found</div>;
  }

  return (
    <>
      <br /><br />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', marginRight: '10%' }}>
        <input
          type="text"
          placeholder="Search Device ID"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ padding: '8px', width: '300px' }}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', width: '90%', marginBottom: '5%' }}>
        <PaginationTable
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      <table ref={NewDevice} align="center" width="60%" border={1}>
        <thead>
          <tr className="tableheader">
            <th colSpan={userRole === "10" ? 11 : 10}>Registered Device Id's</th>
          </tr>
          <tr className="tableheader">
            <th rowSpan={3}>Sl.No</th>
             <th rowSpan={3}>District Name</th>
            <th rowSpan={3}>Office Name</th>
            <th rowSpan={3}>FPS Id</th>
            <th rowSpan={3}>Device No</th>
            <th rowSpan={3}>Vendor</th>
            <th rowSpan={3}>Mapped to FPS</th>
            <th rowSpan={3}>Dealer Name</th>
            <th rowSpan={3}>Dealer Mobile</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={item.terminal_id}>
              <td align="center">{index + 1}</td>
              <td align="left">{item.districtName}</td>
              <td align="left">{item.officeName}</td>
              <td align="left"> {item.fps_id}</td>
              <td>{item.terminal_id}</td>
              <td align="left">{item.vendor_id}</td>
              <td align="left">{item.fps_status}</td>
              <td align="left">{item.dealerName}</td>
              <td align="right">{item.dealerMobile || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <br /><br />
            <br /><br />


      <div id="detailsRR" ref={NewDevice}>{renderContenttttt}</div>
            <br /><br />

    </>
  );
};

export default Device_Addition;
